export const enum TabNames {
  WORKSPACE = 'workspace',
  LOGS = 'logs',
  PROFILE = 'profile',
  CODES = 'codes',
  ORGANIZATIONS = 'organizations',
}
